import { render, staticRenderFns } from "./yexiangjinbi.vue?vue&type=template&id=178db8bc&scoped=true"
import script from "./yexiangjinbi.vue?vue&type=script&lang=js"
export * from "./yexiangjinbi.vue?vue&type=script&lang=js"
import style0 from "./yexiangjinbi.vue?vue&type=style&index=0&id=178db8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178db8bc",
  null
  
)

export default component.exports